export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20coral%20and%20warm%20peach%20tones%2C%20delicate%20organic%20flowing%20shapes%20and%20gentle%20curves%2C%20airy%20luxurious%20composition%20with%20subtle%20texture%2C%20elegant%20modern%20editorial%20style%2C%20no%20text%2C%20high%20end%20fashion%20catalog%20atmosphere%2C%20light%20and%20sophisticated%20feel&width=1800&height=800&seq=cta-main-vigorbuy-11&orientation=landscape&nocache=true"
          alt="Vigorbuy Spreadsheet CTA background"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4 text-balance">
          Ready To Explore Vigorbuy Spreadsheet?
        </h2>
        <p className="text-white/75 text-base mb-8 max-w-lg mx-auto">
          Start discovering organized product resources, expert guides, and shopping information today. Join thousands of smart shoppers using <strong className="text-white">Vigorbuy Spreadsheet 2026</strong>.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3 rounded-md bg-white text-foreground-950 font-semibold text-sm hover:bg-white/90 transition-all whitespace-nowrap"
          >
            Visit Main Website
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}